"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessageSubscriberRegistry = /** @class */ (function () {
    function MessageSubscriberRegistry(window) {
        var _this = this;
        this.messageSubscribers = new Map();
        // Add Subscriber
        this.addSubscriber = function (action, subscriber) {
            if (_this.messageSubscribers.has(action)) {
                var subscribers = _this.messageSubscribers.get(action);
                subscribers.push(subscriber);
                _this.messageSubscribers.set(action, subscribers);
            }
            else {
                _this.messageSubscribers.set(action, [subscriber]);
            }
        };
        // Remove Subscriber
        this.removeSubscriber = function (action, subscriber) {
            /* istanbul ignore else */
            if (_this.messageSubscribers.has(action)) {
                var subscribers = _this.messageSubscribers.get(action);
                var subIndex = subscribers.findIndex(function (sub) {
                    return sub === subscriber;
                });
                subscribers.splice(subIndex, 1);
                _this.messageSubscribers.set(action, subscribers);
            }
        };
        // Listen Post Message
        window.addEventListener('message', function (event) {
            var message = event.data;
            var subscribers = _this.messageSubscribers.get(message.action);
            /* istanbul ignore else */
            if (subscribers) {
                subscribers.forEach(function (subscriber) {
                    subscriber(message);
                });
            }
        });
    }
    MessageSubscriberRegistry.getInstance = function (parentObject) {
        /* istanbul ignore else */
        if (!MessageSubscriberRegistry.instance) {
            MessageSubscriberRegistry.instance = new this(parentObject);
        }
        return MessageSubscriberRegistry.instance;
    };
    return MessageSubscriberRegistry;
}());
exports.default = MessageSubscriberRegistry;
//# sourceMappingURL=MessageSubscriberRegistry.js.map